import type { FleetGroup } from './FleetGroup.ts';
import type { Tour } from './Tour.ts';
import type { Vehicle } from './Vehicle.ts';

export const getVehicleFleetGroupName = (vehicle: Vehicle | undefined, fleetGroups: FleetGroup[] = []) => {
    if (!vehicle) {
        return undefined;
    }

    if (vehicle.fleetGroupName) {
        return vehicle.fleetGroupName;
    }

    if (!vehicle.fleetGroupIds?.length) {
        return undefined;
    }

    const fleetGroupNames = vehicle.fleetGroupIds
        .map(groupId => fleetGroups.find(group => group.id === groupId)?.name)
        .filter((groupName): groupName is string => typeof groupName === 'string' && groupName.trim() !== '');

    return fleetGroupNames.length > 0 ? fleetGroupNames.join(', ') : undefined;
};

export const getTourVehicle = (tour: Tour, vehicles: Vehicle[]) =>
    vehicles.find(vehicle => vehicle.id === tour.truck.id);
